import { Entity } from '@hglobal/common';

export enum VotesAndSurveysStatus {
  Open = 'open',
  Completed = 'completed',
  Expired = 'expired',
}

export interface BaseListModel extends Entity {
  name: string;
  isAnonymous: boolean;
  status: VotesAndSurveysStatus;
}

export interface VotesAndSurveysListModel extends BaseListModel {
  reward: number;
  startedAt: string;
  expiredAt: string;
  isFinished?: boolean;
  achievementImageUrl?: string;
}

export interface PulseListModel extends BaseListModel {
  completedDate: string;
  reaction: number;
}

export enum PulseReactions {
  VeryBad = 'very-bad',
  Bad = 'bad',
  Neutral = 'neutral',
  Good = 'good',
  VeryGood = 'very-good',
}

export interface PulseReaction {
  id: PulseReactions;
  value: number;
  label: string;
  image: string;
}
